import React, { useState, useEffect } from "react";
import TreeContainer from "./TreeContainer";
import { ownStore } from "../../AppOwnState/ownState";
import {
  ExecuteLayoutEventMethods,
  GetControlPropertyFromStoreOrRefData,
  getProcessedDynamic,
} from "../../General/commonFunctions";

const MenuTree = (props) => {
  const [tree1, setTree1] = useState([]);
  const [tree2, setTree2] = useState([]);

  useEffect(() => {
    if (!props?.dset) return;

    const unsubscribe = ownStore?.subscribe((storeInfo) => {
      setTree1(storeInfo?.data);
    }, props.dset);

    return () => unsubscribe && unsubscribe();
  }, [props?.dset]);

  const updateTree = (treeKey, updated) => {
    if (treeKey === "tree1") {
      ownStore.dispatch({
        type: "STORE_DATASET",
        payload: {
          dataSetName: props?.dset,
          data: updated,
        },
      });
    } else setTree2(updated);
  };
  // const updateTree = (treeKey, updated) => {
  //   if (treeKey === "tree1") setTree1(updated);
  //   else setTree2(updated);
  // };
  const handleSelectItem = (node) => {
    if (props.whenfocusedrowchanged) {
      const onselect = getProcessedDynamic(props.whenfocusedrowchanged, node);
    }
  };

  const handleDoubleClick = (node) => {
    if (props.whenrowdblclick) {
      const onDblClick = getProcessedDynamic(props.whenrowdblclick, node);
      console.log(onDblClick, "onselect");
    }
  };
  return (
    <TreeContainer
      handleSelectItem={handleSelectItem}
      tree1={tree1}
      tree2={tree2}
      onChange={updateTree}
      onDoubleClick={handleDoubleClick}
      template={props.content}
    />
  );
};

export default MenuTree;
